/**
 * Admin RBAC Audit Module Routes (Expansão v2 / Épico E5 / Story E5.1.3).
 *
 * Rota single ``/admin/rbac-audit`` — tela admin meta read-only que
 * consome os 5 endpoints E5.1.1 sob ``/api/v1/admin/rbac/*``.
 *
 * **Por que NÃO registrar em ``system_modules``** (CLAUDE.md "criar
 * módulo novo"):
 *
 * A regra do CLAUDE.md aplica a módulos de negócio cross-cutting
 * (lotese, vpn, rh) que aparecem em ``/admin/modules`` (raio-X) e podem
 * ser colocados em manutenção. ``/admin/rbac-audit`` é tela admin meta
 * — equivalente a ``/admin/permissoes`` e ``/admin/perfis`` (CRUDs
 * existentes que **também não estão** em ``system_modules``). Registrar
 * RBAC Audit como módulo poluiria o catálogo e exigiria health check
 * + migration sem ganho prático (ninguém vai ativar manutenção "do
 * RBAC Audit").
 *
 * Decisão registrada na spec ``docs/implementation-artifacts/
 * spec-e5-1-3-rbac-audit-ui.md`` (Boundaries → Ask First).
 *
 * **Permission gate:**
 *
 * Backend exige ``admin:rbac:view`` em todos os endpoints (Story E5.1.1).
 * ``RequirePermission`` no frontend evita request inútil + redireciona
 * pra ``/unauthorized`` se user não tem.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const RBACAuditPage = lazy(() => import("@/pages/admin/RBACAuditPage"));

export const adminRbacRoutes: ModuleRoutes = {
  moduleId: "admin_rbac",
  basePath: "/admin/rbac-audit",
  routes: [
    {
      path: "/admin/rbac-audit",
      element: <RBACAuditPage />,
      permission: { resource: "admin", action: "rbac:view" },
    },
  ],
};
